export enum EHeaderCellType {
    TEXT = 'text',
    HIGHLIGHT_BLUE = 'highlight_blue',
    HIGHLIGHT_ORANGE = 'highlight_orange',
    HIGHLIGHT_GREEN = 'highlight_green',
    HIGHLIGHT_YELLOW = 'highlight_yellow',
    BOLD_PRIMARY = 'bold_primary',
}

export enum EFilterType {
    // Common filter types
    includesString = 'includesString',
    inNumberRange = 'inNumberRange',
    inDateRange = 'inDateRange',
    equalsSelect = 'equalsSelect',
    multiSelect = 'multiSelect',

    // Special filter types
    dispatcherState = 'dispatcherState',
    offerState = 'offerState',
}

export const DEFAULT_PAGE_SIZE_OPTIONS = [50, 100, 200, 300];
export const TABLE_COLUMN_SIZES_STORAGE_KEY_PREFIX = 'tableColumnSizes-';
export const TABLE_PAGE_SIZE_STORAGE_KEY_PREFIX = 'tablePageSize-';
export const TABLE_COLUMN_VISIBILITY_STORAGE_KEY_PREFIX = 'tableColumnVisibility-';
export const TABLE_COLUMN_ORDER_STORAGE_KEY_PREFIX = 'tableColumnOrder-';
